import React, { useEffect, useState } from "react";
import Header from "../Header/Header";

import AttendanceStatsCards from "./AttendanceStatsCards";
import AttendanceEmployeeList from "./AttendanceEmployeeList";

import teamServices from "../Services/teamServices";
import CustomSelect from "../../components/common/CustomSelect";
import { ToastContainer } from "react-toastify";
import CustomTitle from "../../GeoLocationCompoents/Custom/CustomTitle";
import useScrollToTop from "../../components/hooks/useScrollToTop";

const AnalyticsPage = () => {
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split("T")[0]);
  const [selectedTeam, setSelectedTeam] = useState({ value: "", label: "All Teams" });

  const [teamList, setTeamList] = useState([])

  const fetchTeamList = async () => {
    try {
      const response = await teamServices.getGeoLocationTeamList();
      if (response && response.data) {
        setTeamList(response.data);
        const teams = response.data || [];
        setTeamList(
          [
           { value: "", label: "All Teams" },
           ...teams.map(team => ({ value: team.value, label: team.label }))
          ]
         );
         
        
      }
    } catch (error) {
      console.error("Error fetching team list:", error);
    }
  };
  useEffect(() => {
    fetchTeamList();
  }, []);

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);  
  };


  useScrollToTop()
  return (
    <div className="min-h-screen bg-appGrayBackground">
      <Header />
      <ToastContainer/>
      <div className="px-6 pt-28 pb-10">
        <div className="flex justify-between items-center mb-8">
          <CustomTitle title={"Today Summary"} textColor={"primary"} />
          
    
          <div className="flex items-center gap-4">
          <div className="w-64">
          <CustomSelect
  options={teamList}
  value={selectedTeam}
  onChange={(option) => setSelectedTeam(option)}
  placeholder="Select Team"
  isClearable={false}
/>

          </div>
            <div className="flex items-center gap-2 bg-white rounded-lg px-3 py-2 border border-gray-200">
              <input
                type="date"
                value={selectedDate}    
                onChange={handleDateChange}
                className="border border-gray-300 rounded-lg px-3 py-1 focus:outline-none "
              />  
            </div>
            
    
          </div>
        </div>
        
      
        <AttendanceStatsCards selectedTeam={selectedTeam}  selectedDate={selectedDate} />
        
       
        <AttendanceEmployeeList selectedTeam={selectedTeam}  selectedDate={selectedDate} />
      </div>
    </div>
  );
};

export default AnalyticsPage;
